import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { sendReport } from "../../helpers/report";
import { Col, Row, notification } from "antd";
import { trackEvent } from "../../helpers/mixpanel";
import CustomSheet from "../CustomSheet";
import userModel from "../../lib/firebase/userModel";
import { AuthContext } from "../../context/AuthProvider";

export default function ReportUserSheet({ isOpen, setOpen, user }) {
  const [api, contextHolder] = notification.useNotification();
  const { user: currentUser } = useContext(AuthContext);
  const [isSending, setIsSending] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  const openNotification = () => {
    const key = `open${Date.now()}`;
    api.open({
      description: (
        <Row>
          <Col span={22}>
            We have received your report. Thank you for keeping our community safe!
          </Col>
          <Col span={2}></Col>
        </Row>
      ),
      key,
      duration: 10,
      className: "report-notification",
      closeIcon: <CloseIcon src="/icons/x-icon-gray.svg" alt="" />,
    });
  };

  useEffect(() => {
    async function fetchData() {
      const userInfo = await userModel.getOneById(user);
      setUserInfo(userInfo);
    }
    if (user) fetchData();
  }, [user]);

  const startSendingReport = async () => {
    setIsSending(true);
    const reportedByUser = await userModel.getOneById(currentUser?.uid);
    const reportedUser = await userModel.getOneById(user);
    const data = {
      profileLink: window.location.toString(),
      reportedBy: {
        username: reportedByUser.username,
        email: reportedByUser.email,
        id: reportedByUser.id,
      },
      reportedUser: {
        username: reportedUser.username,
        email: reportedUser.email,
        id: reportedUser.id,
      },
    };
    const result = await sendReport(data);
    if (result.success) {
      openNotification();
      setOpen(false);
    }
    setIsSending(false);
    trackEvent("Reported User", {
      reported_user_id: reportedUser.id,
      reported_user_email: reportedUser.email,
      reported_user_username: reportedUser.username,
      reported_by_user_id: reportedByUser.id,
      reported_by_user_email: reportedByUser.email,
      reported_by_user_username: reportedByUser.username,
    });
  };

  useEffect(() => {
    if (isOpen) setIsSending(false);
  }, [isOpen]);

  return (
    <>
      {contextHolder}
      <CustomSheet
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        snapPoints={[325]}
        tweenConfig={{ ease: "easeOut", duration: 0.3 }}
      >
        <InnerContainer>
          <ProfileImage src={userInfo && userInfo.pfp} alt="" />
          <Header>Report {userInfo && userInfo.username}?</Header>
          <Content>
            Submit a report to us if you see a profile that may violate{" "}
            <PinkText
              onClick={() => {
                window.open("/guidelines");
              }}
            >
              guidelines
            </PinkText>
            .
          </Content>
          {!isSending ? (
            <SendReportButton onClick={async () => await startSendingReport()}>
              Report
            </SendReportButton>
          ) : (
            <SendReportButton disabled>
              <Spinner alt="" src="/icons/loading-spheres.svg" />
            </SendReportButton>
          )}
        </InnerContainer>
      </CustomSheet>
    </>
  );
}

const Header = styled.div`
  color: var(--color-cream-base);
  text-align: center;
  font-family: var(--font-primary);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-top: 14px;
`;

const Content = styled.div`
  color: var(--color-gray-50);
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 22.4px */
  margin-top: 12px;
`;

const InnerContainer = styled.div`
  width: 85%;
  margin: 0px auto;
  text-align: center;
`;

const CloseIcon = styled.img`
  height: 10px;
  width: 10px;
  position: absolute;
  opacity: 0.5;
`;

const Spinner = styled.img`
  width: 25px;
  height: 25px;
  animation: rotation 2s infinite linear;
`;

const SendReportButton = styled.button`
  width: 100%;
  height: 50px;
  background: var(--blurple);
  border: 0;
  border-radius: 90px;
  margin-top: 20px;
  cursor: pointer;
  line-height: 16px;
  display: flex;
  padding: 16px 20px;
  justify-content: center;
  text-align: center;
  align-items: center;
  align-self: stretch;
  color: var(--color-cream-base);
  font-family: var(--font-primary);
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
`;

const PinkText = styled.span`
  color: var(--color-pink);
`;

const ProfileImage = styled.img`
  height: 82px;
  width: 82px;
  text-align: center;
  margin-top: 14px;
  border-radius: 82px;
  border: 2px solid #252525;
`;
